import BaseApi from './BaseApi';

type ChatData = {
  cursor: unknown;
  chatList: {
    inquiryData: {
      siteCd: string;
      matchId: string;
      lineId: string;
      propertyNo: string;
      title: string;
      inquiryDetail: string;
      inquiryDetailText: string;
      name: string;
      mail: string;
      phone: string;
      scheduledMoveInPeriod: string;
    };
    chatMessage: {
      /**
       * メッセージの送信方向
       * 0: ユーザー -> 加盟店
       * 1: 加盟店 -> ユーザー
       * 2: System -> ユーザー
       * 3: System
       */
      sendingDirection: '0' | '1' | '2' | '3';
      alreadyReadFlg: boolean;
      message?: string;
      image?: string;
      chatId: string;
    };
  }[];
};

/**
 * LINE問い合わせ最新チャット情報取得API。
 */
class GetKaiinChatNewLineChatListApi extends BaseApi {
  async get(cursor: unknown, limit = 100) {
    return await this.execute('getKaiinChatNewLineChatListApi', {
      method: 'POST',
      body: {
        limit,
        cursor: cursor ? JSON.stringify(cursor) : null
      }
    }).then(({ result }) => result as ChatData);
  }
}

export default GetKaiinChatNewLineChatListApi;
